module.exports = __webpack_public_path__ + "img/10-01_24.52514018.png";